export const ROOT = '/hours_schedules';
export const MODULE = 'HoursSchedules';
